/*************************************************************************
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { Fragment } from "react";
import { ProgressCircle } from "@react-spectrum/progress";
import { FormattedMessage } from "react-intl";
import ProgressViewCss from "./ProgressView.css";

const FallbackPrintProgressView = () => {
  const renderSpinnerText = () => (
    <div className={ProgressViewCss.modernViewerProgressText}>
      <FormattedMessage id="print.fallbackPrint.loader.msg" />
    </div>
  );

  const renderSpinner = () => (
    <div className={ProgressViewCss.modernFallbackSpinnerParent}>
      <div className={ProgressViewCss.modernViewerFallbackWaitSpinner}>
        <ProgressCircle data-testid="fallback-ProgressCircle" isIndeterminate size="S" />
      </div>
      {renderSpinnerText()}
    </div>
  );

  return <div className={ProgressViewCss.modernViewProgressParent}>{renderSpinner()}</div>;
};

export default FallbackPrintProgressView;
